import * as dagJson from '@ipld/dag-json';
import { resolveObjectPath } from '../utils/resolve-object-path.js';
const resolve = async (cid, name, path, toResolve, resolve, depth, blockstore, options) => {
    const block = await blockstore.get(cid, options);
    const object = dagJson.decode(block);
    return resolveObjectPath(object, block, cid, name, path, toResolve, depth);
};
export default resolve;
//# sourceMappingURL=dag-json.js.map